import { jsx as ___EmotionJSX } from "@emotion/core";
import * as React from "react";

const Option = props => {
  return ___EmotionJSX("option", null, props.children);
};

export default Option;